import React from 'react';
import { Link } from 'react-router-dom';
import { FeatureCard, PanelHeader } from 'js/components';
import {
  faAnalytics,
  faClipboardListCheck,
  faHourglassHalf,
} from '@fortawesome/pro-regular-svg-icons';

import styles from './AssessmentsTeaser.module.scss';
import UpgradeNudge from 'js/components/UpgradeNudge';
import { useFlags } from 'js/hooks/useFlags';
import { Card, CardBody } from 'reactstrap';

const AssessmentsTeaser = ({ account }) => {
  const flags = useFlags();

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-content px-4">
          <div className="orgs-panel-header">
            <div>
              <h1>Create your own assessments</h1>
              <p>
                Paid tiers allow you to create your own assessments and take
                advantage of all the built-in analysis and visualizations used
                by our offical assessments.
              </p>
            </div>
          </div>
        </div>
      </PanelHeader>
      <div className="content">
        <UpgradeNudge>
          <p>
            Custom assessments aren't included in Waypointr's free or basic
            tiers.
          </p>
          {flags.stripe ? (
            <p>
              <Link to={`/a/${account?.id}/settings/billing`}>Upgrade</Link> to
              the Basic or Premium plan to build your own assessments to track
              what matters most to your organization!
            </p>
          ) : (
            <p>
              Contact{' '}
              <a href="mailto:support@waypointr.com">support@waypointr.com</a>{' '}
              to find a reseller or get on the list to be part of our our closed
              beta.
            </p>
          )}
          <p>
            This is just a sampling of the features you'll get with a paid tier:
          </p>
        </UpgradeNudge>
        <section>
          <Card>
            <CardBody className={styles.cards}>
              <FeatureCard
                src="/static/media/editor/editor.png"
                alt="Org Tree"
                title="Build your own assessments"
                icon={faClipboardListCheck}
                className={styles.feature}
              >
                <p>
                  Standard assessments are great for tapping into common trends
                  across industries, but what if you have to play by different
                  rules? Custom assessments allow you to build your own
                  assessments to track what the things that give your teams an
                  edge in the real world.
                </p>
              </FeatureCard>
              <FeatureCard
                src="/static/media/editor/revisions.png"
                alt="Org Tree"
                title="Evolve your assessments over time"
                icon={faHourglassHalf}
                className={styles.feature}
              >
                <p>
                  No organizational strategy or structure stays the same
                  forever. You should be able to evolve your assessments over
                  time to reflect the changes in your organization while
                  preserving your historical trends. Waypointr lets you do that.
                </p>
              </FeatureCard>
              <FeatureCard
                src="/static/media/orgs/analytics.png"
                alt="Org Tree"
                title="Leverage our built-in analysis"
                icon={faAnalytics}
                className={styles.feature}
              >
                <p>
                  Waypointr's built-in analysis tools help you see the big
                  picture and identify trends. Use the same tools for your
                  custom assessments as you do for our offical ones.
                </p>
              </FeatureCard>
            </CardBody>
          </Card>
        </section>
      </div>
    </div>
  );
};

export default AssessmentsTeaser;
